<template>
  <div :class="rootClass" class="ad-wrap" ref="wrap">
    <ClientOnly>
      <ins
        v-if="visible"
        class="adsbygoogle"
        :class="insClass"
        :style="insStyle"
        :data-ad-client="dataAdClient"
        :data-ad-slot="dataAdSlot"
        :data-ad-test="dataAdTest"
        :data-ad-format="dataAdFormat || undefined"
        :data-ad-region="dataAdRegion"
        :data-full-width-responsive="dataFullWidthResponsive === 'yes'"
      ></ins>
    </ClientOnly>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { initAdsenseOnPage } from '~/util/adsense'
import propsUtils from './util/props'

const props = defineProps({ ...propsUtils })

const wrap = ref(null)
const visible = ref(false)

onMounted(() => {
  const obs = new IntersectionObserver(
    async ([entry]) => {
      if (!entry.isIntersecting || visible.value) return
      visible.value = true

      await nextTick()
      // inicijalizuj oglase tek kad je slot u DOM-u i vidljiv
      initAdsenseOnPage(false)

      obs.disconnect()
    },
    { rootMargin: '200px' } // krene malo pre nego sto udje u ekran
  )

  if (wrap.value) obs.observe(wrap.value)
})
</script>
